import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders }    from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IUserProfile } from '../user-profile/user-profile';

@Injectable()
export class UserProfileService {
  private  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  getProfiles(): Observable<IUserProfile> {
    const URL = `${this.baseUrl}/api/userprofile/getProfiles`;
    return this.http.get<IUserProfile>(URL);
  }

}